import dayjs, { Dayjs } from 'dayjs';

export const fromLocalDate = (localDate: string): Dayjs => dayjs(localDate, 'YYYY-MM-DDTHH:mm:ss');
